module.exports = __webpack_public_path__ + "media/images/payments/ingenico-ff89497ff4569bd2a537f07f49d076d5.svg";